export default "__VITE_ASSET__jXKny77y__"